import { useState } from "react";
import Botones from "../../../global/BotonBase";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { InputAdornment, IconButton } from "@material-ui/core"
import styles from "./styles";
import { ToastMessage } from "../../../global/ToastMessage";
import { useFormik } from "formik";
import * as yup from "yup";
import BackDrop from "./../../../global/BackDrop";
import { useDispatch } from "react-redux";
import { LogeoIntAction } from "./../../../ducks/logeoDuck";
import { VisibilityOff, Visibility } from "@material-ui/icons";
const validationSchema = yup.object({
  email: yup
    .string("Ingresa tu usuario")
    .required("Usuario es requerido"),
  password: yup
    .string("Ingresa tu contraseña")
    .min(2, "Contraseña debe de tener minimo 2 caracteres")
    .required("Contraseña es requerido"),
});

const FLogin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoad, setIsLoad] = useState(false);
  const [show, setShow] = useState(false)
  const classes = styles();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setIsLoad(true);
      let payload = {
        UserName: values.email,
        Password: values.password
      }
      dispatch(LogeoIntAction(payload)).then((Response) => {
        setIsLoad(false)
        if (Response?.status === 500) {
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          return null
        }
        if (Response?.status === 400) {
          ToastMessage.fire({
            icon: "warning",
            text: Response?.Message,
          });
          return null
        }

        ToastMessage.fire({
          customClass: {
            container: classes.swaltoast,
          },
          icon: "success",
          title: "Ingreso Correcto",
        });
        history.push("/Home");
      });
    },
  });
  const handleClickShowPassword = () => {
    setShow(!show)
  }
  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container>
        <Grid item xs={12} direction="column" justifyContent="center" alignItems="center" style={{ padding: "0 25%", textAlign: "center" }}>
          <div className={classes.TituloLogeo}>Bienvenido</div>
          <div className={classes.SubtituloLogeo}>
            Para comenzar inicia sesión.
          </div>
          <TextField
            required
            id="outlined-required"
            label="Usuario"
            variant="outlined"
            name="email"
            style={{ width: "100%", margin: "5px 0" }}
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <TextField
            required
            id="outlined-password-input"
            label="Contraseña"
            type={show ? 'text' : 'password'}
            autoComplete="current-password"
            variant="outlined"
            name="password"
            style={{ width: "100%", margin: "5px 0" }}
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            InputProps={{
              endAdornment: <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {show ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12} direction="column" justifyContent="center" alignItems="center" style={{ padding: "0 25%", textAlign: "center" }}>
          <Botones type="submit" />
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </form>
  );
};
export default FLogin;
